module.exports = __webpack_public_path__ + "img/3min_exam.93fc7f1f.png";